import { connect } from "react-redux";
import MerchandisingMediasIntro from "app/pages/Merchandising/Media/MerchandisingMediasIntro";
import { getMerchandisingDescription } from "app/pages/Merchandising/merchandisingSelector";

const mapStateToProps = state => {
	const currentMerchandising = state.merchandising.current;

	return {
		mediaIntroduction: getMerchandisingDescription(state),
		fromPrice: currentMerchandising?.lowestPrice,
	};
};

export default connect(mapStateToProps)(MerchandisingMediasIntro);
